
import { Answer, SubAnswer } from "../../../utils/interface/answer"
import DataRenderer from "../../render";

interface SectionProps {
    question: Answer;
}

export default function GenericAnswer(props: SectionProps) {

    const { question } = props;

    const renderExplanation = () => {
        try {
            return (
                <>

                    <span className="answer_explanation" style={question.correct_answer_text == null ? { marginTop: 0 } : undefined}>Explanation - </span>

                    <div className="question_options">
                        <ol type={'i'} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                            {question.answer_explanation.map((exp, index) => (
                                <li style={{ marginRight: '10px', fontSize: 16, marginBottom: 10, display: 'flex', flexDirection: 'row' }} key={index}>
                                    <span style={{ marginRight: 5 }}></span>
                                    <DataRenderer text={exp} type='mathpix' />
                                </li>))
                            }
                        </ol>
                    </div>
                </>
            )
        } catch (error) {
            return <></>
        }
    }

    const renderSubExplanation = (sub: SubAnswer) => {
        try {
            return (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className="answer_explanation">Explanation - </span>
                    <ol type={'i'} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                        {sub.answer_explanation && sub.answer_explanation.map((exp2, index) => (
                            <li style={{ marginRight: '10px', fontSize: 16, marginBottom: 10, display: 'flex', flexDirection: 'row' }} key={index}>
                                <span style={{ marginRight: 5 }}></span>
                                <DataRenderer text={exp2} type='mathpix' />
                            </li>))
                        }
                    </ol>
                </div>
            )
        } catch (error) {
            <></>
        }
    }

    try {
        return (

            <div className="question answer_key">
                <h3 className="question_text">
                    <span className="question_number">Q{question.question_number}.</span>
                    <div className="answer_content">
                        {question.correct_answer_text && question.correct_answer_text !== null &&
                            <DataRenderer text={question.correct_answer_text} type='mathpix' />
                        }

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {question.sub_question && question.sub_question.length > 0 &&
                                <div className="mcq-options" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%', marginTop: 20 }}>
                                    {/* <h3 style={{ fontWeight: 'bold',textDecoration:'underline' }}>Answer the following - </h3> */}
                                    {question.sub_question && question.sub_question.map((sub, index) => (
                                        <div style={{ marginBottom: 10, paddingBottom: 10, borderBottom: '1px solid lightgray' }} key={index}>
                                            <span style={{ marginRight: '10px', fontSize: 16, display: 'flex' }}>
                                                <span style={{ fontWeight: 'bold', marginRight: 5 }}>{sub.sub_question_number})</span>
                                                {
                                                    sub.correct_answer && <DataRenderer text={sub.question_text} type='mathpix' />
                                                }


                                            </span>
                                            {renderSubExplanation(sub)}

                                        </div>
                                    ))
                                    }
                                </div>
                            }
                        </div>
                        {
                            question.answer_explanation && question.answer_explanation.length > 0 &&
                            renderExplanation()
                        }
                    </div>

                </h3>
                {
                    question.data &&
                    question.data.type === 'image' &&
                    <div className="question_data">
                        <img src={question.data.value} alt="Question" />
                    </div>
                }
            </div>

        )
    } catch (error) {
        return (
            <></>
        )
    }



}